/**
 * @desc 更新物流方式
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.UpdateShippingMethodRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackage/updateShippingMethod`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
